import { render } from "./TextLabel.vue?vue&type=template&id=67f9a5b3&ts=true"
import script from "./TextLabel.vue?vue&type=script&lang=ts"
export * from "./TextLabel.vue?vue&type=script&lang=ts"

import "./TextLabel.vue?vue&type=style&index=0&id=67f9a5b3&lang=scss"

import exportComponent from "/Users/colin/Documents/FUSE/code/live/fusestudio.net/Graphite/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__